export default "__VITE_ASSET__E7Jx5jxv__"